import {CALCULATOR_TYPES, getCalculatorType, numberToCurrency} from "./helpers";

export const getWhatsAppShareText = (state, shareUrl, intl) => {

  //console.log('getWhatsAppShareText', state, shareUrl, intl)
  let shareText = '';
  if (getCalculatorType() === CALCULATOR_TYPES.hoeveelKanIkLenen) {
    //console.log(state);
    if (!state.HasPartner && state.Woning === 0) {
      //Scenario 1: Hoeveel kan ik lenen – no partner – no new house
      //shareText = shareText + `Ik heb mijn maximale hypotheek berekend op hypotheker.nl. Ik mag maximaal ${numberToCurrency(state.response.maxMortgageAmount, true)} lenen. Dat kost bruto per maand ${numberToCurrency(state.response.grossMonthlyCost, true)}.`;
      shareText += intl.formatMessage({
        id: 'shareHelper.howMuchCanIBorrowNoPartnerNoNewHouse',
        defaultMessage: 'Ik heb mijn maximale hypotheek berekend op hypotheker.nl. Ik mag maximaal {maxMortgageAmount} lenen. Dat kost bruto per maand {grossMonthlyCost}.'
      },
      {
        maxMortgageAmount: numberToCurrency(state.response.maxMortgageAmount, true),
        grossMonthlyCost: numberToCurrency(state.response.grossMonthlyCost, true)
      });
    }

    if (!state.HasPartner && state.Woning > 0) {
      //Scenario 2: Hoeveel kan ik lenen – no partner - new house
      //shareText = shareText + `Ik heb mijn maximale hypotheek berekend op hypotheker.nl. Ik mag maximaal ${numberToCurrency(state.response.maxMortgageAmount, true)} lenen. Dat kost bruto per maand ${numberToCurrency(state.response.grossMonthlyCost, true)}. Voor de woning die ik op het oog heb, moet ik nog ${numberToCurrency(state.response.extraMoneyNeeded, true)} bijleggen. De maandlasten worden voor deze woning ${numberToCurrency(state.response.netMonthlyCostHouse, true)}.`
      shareText += intl.formatMessage({
        id: 'shareHelper.howMuchCanIBorrowNoPartnerNewHouse',
        defaultMessage: 'Ik heb mijn maximale hypotheek berekend op hypotheker.nl. Ik mag maximaal {maxMortgageAmount} lenen. Dat kost bruto per maand {grossMonthlyCost}. Voor de woning die ik op het oog heb, moet ik nog {extraMoneyNeeded} bijleggen. De maandlasten worden voor deze woning {netMonthlyCostHouse}.'
      },
      {
        maxMortgageAmount: numberToCurrency(state.response.maxMortgageAmount, true),
        grossMonthlyCost: numberToCurrency(state.response.grossMonthlyCost, true),
        extraMoneyNeeded: numberToCurrency(state.response.extraMoneyNeeded, true),
        netMonthlyCostHouse: numberToCurrency(state.response.netMonthlyCostHouse, true)
      });
    }

    if (state.HasPartner && state.Woning === 0) {
      // Scenario 3: Hoeveel kan ik lenen – with partner – no new house
      //shareText = shareText + `Ik heb onze maximale hypotheek berekend op hypotheker.nl. We mogen maximaal ${numberToCurrency(state.response.maxMortgageAmount, true)} lenen. Dat kost bruto per maand  ${numberToCurrency(state.response.grossMonthlyCost, true)}.`
      shareText += intl.formatMessage({
        id: 'shareHelper.howMuchCanIBorrowWithPartnerNoNewHouse',
        defaultMessage: 'Ik heb onze maximale hypotheek berekend op hypotheker.nl. We mogen maximaal {maxMortgageAmount} lenen. Dat kost bruto per maand {grossMonthlyCost}.'
      },
      {
        maxMortgageAmount: numberToCurrency(state.response.maxMortgageAmount, true),
        grossMonthlyCost: numberToCurrency(state.response.grossMonthlyCost, true)
      }
      );
    }

    if (state.HasPartner && state.Woning > 0) {
      // Scenario 4: Hoeveel kan ik lenen – with partner – new house
      //shareText = shareText + `Ik heb onze maximale hypotheek berekend op hypotheker.nl. We mogen maximaal ${numberToCurrency(state.response.maxMortgageAmount, true)} lenen. Dat kost bruto per maand  ${numberToCurrency(state.response.grossMonthlyCost, true)}. Voor de woning die we op het oog hebben, moeten we nog ${numberToCurrency(state.response.extraMoneyNeeded, true)} bijleggen. De maandlasten voor deze woning worden ${numberToCurrency(state.response.netMonthlyCostHouse, true)}.`
      shareText += intl.formatMessage({
        id: 'shareHelper.howMuchCanIBorrowWithPartnerNewHouse',
        defaultMessage: 'Ik heb onze maximale hypotheek berekend op hypotheker.nl. We mogen maximaal {maxMortgageAmount} lenen. Dat kost bruto per maand {grossMonthlyCost}. Voor de woning die we op het oog hebben, moeten we nog {extraMoneyNeeded} bijleggen. De maandlasten voor deze woning worden {netMonthlyCostHouse}.'
      },
      {
        maxMortgageAmount: numberToCurrency(state.response.maxMortgageAmount, true),
        grossMonthlyCost: numberToCurrency(state.response.grossMonthlyCost, true),
        extraMoneyNeeded: numberToCurrency(state.response.extraMoneyNeeded, true),
        netMonthlyCostHouse: numberToCurrency(state.response.netMonthlyCostHouse, true)
      }
      );
    }
  }

  if (getCalculatorType() === CALCULATOR_TYPES.watWordenMijnMaandLasten) {
    if (!state.HasPartner) {
      // Scenario 5: Wat worden mijn maandlasten – no partner
      //shareText = shareText + `Ik heb mijn maandlasten uitgerekend op hypotheker.nl. Voor een gewenste hypotheek van ${numberToCurrency(state.response.purchasePrice, true)} zijn de netto maandlasten ${numberToCurrency(state.response.netMonthlyCostHouse, true)}`
      shareText += intl.formatMessage({
        id: 'shareHelper.whatWillBeMyMonthlyCostsNoPartner',
        defaultMessage: 'Ik heb mijn maandlasten uitgerekend op hypotheker.nl. Voor een gewenste hypotheek van {purchasePrice} zijn de netto maandlasten {netMonthlyCostHouse}'
      },
      {
        purchasePrice: numberToCurrency(state.response.purchasePrice, true),
        netMonthlyCostHouse: numberToCurrency(state.response.netMonthlyCostHouse, true)
      }
      );
    }
    if (state.HasPartner) {
      // Scenario 6: Wat worden mijn maandlasten – with partner
      //shareText = shareText + `Ik heb onze maandlasten uitgerekend op hypotheker.nl. Voor een gewenste hypotheek van ${numberToCurrency(state.response.purchasePrice, true)} zijn de netto maandlasten ${numberToCurrency(state.response.netMonthlyCostHouse, true)}`
      shareText += intl.formatMessage({
        id: 'shareHelper.whatWillBeMyMonthlyCostsWithPartner',
        defaultMessage: 'Ik heb onze maandlasten uitgerekend op hypotheker.nl. Voor een gewenste hypotheek van {purchasePrice} zijn de netto maandlasten {netMonthlyCostHouse}'
      },
      {
        purchasePrice: numberToCurrency(state.response.purchasePrice, true),
        netMonthlyCostHouse: numberToCurrency(state.response.netMonthlyCostHouse, true) }
      );
    }
  }

  if (getCalculatorType() === CALCULATOR_TYPES.kanIkDitHuisBetalen) {

    if (!state.HasPartner && state.isHouseAffordable) {
      //Scenario 7: Kan ik dit huis betalen? – no partner – can afford the house
      //shareText = shareText + `Ik heb op hypotheker.nl berekend of ik de woning die ik op het oog heb, kan betalen. Ik mag maximaal ${numberToCurrency(state.response.maxMortgageAmount, true)} lenen en kan dus de woning van ${numberToCurrency(state.Woning, true)}. betalen. Dat kost ${numberToCurrency(state.response.netMonthlyCostHouse, true)} per maand en ik heb ${numberToCurrency(state.response.extraMoneyNeeded, true)} eigen geld nodig.`
      shareText += intl.formatMessage({
        id: 'shareHelper.canIAffordThisHouseNoPartnerCanAfford',
        defaultMessage: 'Ik heb op hypotheker.nl berekend of ik de woning die ik op het oog heb, kan betalen. Ik mag maximaal {maxMortgageAmount} lenen en kan dus de woning van {Woning}. betalen. Dat kost {netMonthlyCostHouse} per maand en ik heb {extraMoneyNeeded} eigen geld nodig.'
      },
      {
        maxMortgageAmount: numberToCurrency(state.response.maxMortgageAmount, true),
        Woning: numberToCurrency(state.Woning, true),
        netMonthlyCostHouse: numberToCurrency(state.response.netMonthlyCostHouse, true),
        extraMoneyNeeded: numberToCurrency(state.response.extraMoneyNeeded, true)
      }
      );
    }

    if (!state.HasPartner && !state.isHouseAffordable) {
      // Scenario 8: Kan ik dit huis betalen? – no partner – can’t afford the house
      //shareText = shareText + `Ik heb op hypotheker.nl berekend of ik de woning die ik op het oog heb, kan betalen. Ik mag maximaal ${numberToCurrency(state.response.maxMortgageAmount, true)} lenen en kan dus de woning van ${numberToCurrency(state.Woning, true)}. niet betalen.`
      shareText += intl.formatMessage({
        id: 'shareHelper.canIAffordThisHouseNoPartnerCantAfford',
        defaultMessage: 'Ik heb op hypotheker.nl berekend of ik de woning die ik op het oog heb, kan betalen. Ik mag maximaal {maxMortgageAmount} lenen en kan dus de woning van {Woning}. niet betalen.'
      },
      {
        maxMortgageAmount: numberToCurrency(state.response.maxMortgageAmount, true),
        Woning: numberToCurrency(state.Woning, true)
      }
      );
    }

    if (state.HasPartner && state.isHouseAffordable) {
      // Scenario 9: Kan ik dit huis betalen? – with partner – can afford the house
      //shareText = shareText + `Ik heb op hypotheker.nl berekend of wij de woning die we op het oog hebben, kunnen betalen. We  mogen maximaal ${numberToCurrency(state.response.maxMortgageAmount, true)} lenen en kunnen dus de woning van ${numberToCurrency(state.Woning, true)}. betalen. Dat kost ${numberToCurrency(state.response.netMonthlyCostHouse, true)} maand en we hebben ${numberToCurrency(state.response.extraMoneyNeeded, true)} eigen geld nodig.`
      shareText += intl.formatMessage({
        id: 'shareHelper.canIAffordThisHouseWithPartnerCanAfford',
        defaultMessage: 'Ik heb op hypotheker.nl berekend of wij de woning die we op het oog hebben, kunnen betalen. We  mogen maximaal {maxMortgageAmount} lenen en kunnen dus de woning van {Woning}. betalen. Dat kost {netMonthlyCostHouse} maand en we hebben {extraMoneyNeeded} eigen geld nodig.'
      },
      {
        maxMortgageAmount: numberToCurrency(state.response.maxMortgageAmount, true),
        Woning: numberToCurrency(state.Woning, true),
        netMonthlyCostHouse: numberToCurrency(state.response.netMonthlyCostHouse, true),
        extraMoneyNeeded: numberToCurrency(state.response.extraMoneyNeeded, true)
      }
      );
    }

    if (state.HasPartner && !state.isHouseAffordable) {
      //Scenario 10: Kan ik dit huis betalen? – with partner – can’t afford the house
      //shareText = shareText + `Ik heb op hypotheker.nl berekend of wij de woning die we op het oog hebben, kunnen betalen. We  mogen maximaal ${numberToCurrency(state.response.maxMortgageAmount, true)} lenen en kunnen dus de woning van ${numberToCurrency(state.Woning, true)}. niet betalen.`
      shareText += intl.formatMessage({
        id: 'shareHelper.canIAffordThisHouseWithPartnerCantAfford',
        defaultMessage: 'Ik heb op hypotheker.nl berekend of wij de woning die we op het oog hebben, kunnen betalen. We  mogen maximaal {maxMortgageAmount} lenen en kunnen dus de woning van {Woning}. niet betalen.'
      },
      {
        maxMortgageAmount: numberToCurrency(state.response.maxMortgageAmount, true),
        Woning: numberToCurrency(state.Woning, true)
      });
    }
  }

  shareText += ` Bekijk de berekening ${shareUrl}`;
  return shareText;
}
